import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetCartById = (cartId) => {
    return useQuery(
        ["get-cart-by-id", cartId],
        () =>
            request({
                url: `cart/admin/id/${cartId}`,
                method: "GET",
            }),
        {
            enabled: !!cartId,
            refetchOnWindowFocus: false,
        }
    );
};

export { GetCartById };
